import SliderInput from 'components/common/slider-input/slider-input'
import { useContext } from 'react'
import { useFormatAmount } from 'core/hooks/useFormatAmount'
import { StoreTrajectoryContext } from '../../state/store-trajectory-context'

interface AccountCardProps {
  icon?: React.ReactNode
  title: string
  amount: number
  percent: number
  disabled?: boolean
  onPercentChange?: (value: number) => void
}

const AccountCard = ({ icon, title, amount, percent, disabled = false, onPercentChange }: AccountCardProps) => {
  const formatAmount = useFormatAmount()

  const { store } = useContext(StoreTrajectoryContext)
  const currency = store?.currency ?? ''

  return (
    <div
      className={`mg-instore-gmv-segment-account-card ${disabled ? 'mg-instore-gmv-segment-account-card-disabled' : ''}`}
    >
      <div className="mg-instore-gmv-segment-account-card-header">
        <div className="mg-instore-gmv-segment-account-card-title-container">
          {icon && <div className="mg-instore-gmv-segment-account-card-icon">{icon}</div>}
          <div className="mg-instore-gmv-segment-account-card-title vp-body-m">{title}</div>
        </div>
        <div className="mg-instore-gmv-segment-account-card-value vp-body-m">{formatAmount(amount, currency)}</div>
      </div>

      <SliderInput value={percent} suffix={'%'} disabled={disabled} onChange={onPercentChange} />
    </div>
  )
}

export default AccountCard
